import { gql } from "@apollo/client";

export const GET_INVOICE_PDF = gql`
  mutation GetInvoicePDF($_id: String!) {
    invoicePDF(_id: $_id)
  }
`;

export const START_INVOICE_PDF_EXPORT = gql`
  mutation StartInvoicePDFExport($invoice_ids: [String!]!) {
    startInvoicePDFExport(invoice_ids: $invoice_ids) {
      _id
      status
      total
      processed
      skipped_count
      error
      filename
    }
  }
`;
